/**
 * List of supported External ID's
 * @param options object of options to build the list
 * @param options.includeEmpty boolean to include an empty name/value pair at the beginning
 */
export function list(options = {}) {
  const list = [
    {
      label: 'AME',
      value: 'ame',
    },
    {
      label: 'Harmony',
      value: 'harmony',
    },
    {
      label: 'Stingray',
      value: 'stingray',
    },
  ];

  if (options.includeEmpty === true) {
    list.unshift({
      label: '',
      value: '',
    });
  }

  return list;
}

export default {
  list,
};
